import { instance } from "libs/api";

import { ApiRoutesDeliveries } from "../../constants";
import { DriverInDeliveriesListItem } from "../../financial.types";
import { GetDriversDeliveriesInfoRequestParams } from "./getDriversDeliveriesInfo.types";

export const requestAllDriversDeliveriesInfo = async (
  params: GetDriversDeliveriesInfoRequestParams
): Promise<DriverInDeliveriesListItem[]> => {
  return await instance.get(ApiRoutesDeliveries.DriversDeliveriesInfo, {
    params
  });
};
